import initialStateLoader from '../initialState';
import { reaction } from '@huggg/back-bar';

export const UPDATE_REACTION = 'huggg/reaction/UPDATE_REACTION';

const LOAD_EMOJI = 'huggg/reaction/LOAD_EMOJI';
const LOAD_EMOJI_SUCCESS = 'huggg/reaction/LOAD_EMOJI_SUCCESS';
const LOAD_EMOJI_ERROR = 'huggg/reaction/LOAD_EMOJI_ERROR';

const LOAD_COMMENT = 'huggg/reaction/LOAD_COMMENT';
const LOAD_COMMENT_SUCCESS = 'huggg/reaction/LOAD_COMMENT_SUCCESS';
const LOAD_COMMENT_ERROR = 'huggg/reaction/LOAD_COMMENT_ERROR';

const { reaction: initialState } = initialStateLoader();

const reducer = (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case LOAD_EMOJI:
      return { ...state, loadingEmoji: true };

    case LOAD_EMOJI_SUCCESS:
      return { ...state, loadingEmoji: false, ...payload };

    case LOAD_EMOJI_ERROR:
      return { ...state, loadingEmoji: false, loadingEmojiError: payload };

    case LOAD_COMMENT:
      return { ...state, loadingComment: true };

    case LOAD_COMMENT_SUCCESS:
      return { ...state, loadingComment: false, ...payload };

    case LOAD_COMMENT_ERROR:
      return { ...state, loadingComment: false, loadingCommentError: payload };

    case UPDATE_REACTION:
      return {
        ...state,
        loadingEmoji: false,
        loadingComment: false,
        ...payload,
      };

    default:
      return state;
  }
};

export default reducer;

export const createEmojiReaction = (emoji) => (dispatch, getState) => {
  const { huggg } = getState();
  dispatch({ type: LOAD_EMOJI });

  reaction
    .create({
      emoji,
      hugggId: huggg.huggg.id,
    })
    .then((response) => {
      dispatch({ type: LOAD_EMOJI_SUCCESS, payload: response });
    })
    .catch((error) => {
      dispatch({ type: LOAD_EMOJI_ERROR, payload: error.message });
    });
};

export const addReactionComment =
  (message = '', name = '') =>
  (dispatch, getState) => {
    const {
      reaction: { id },
    } = getState();
    dispatch({ type: LOAD_COMMENT });

    reaction
      .update(id, {
        name,
        message,
      })
      .then((response) => {
        dispatch({ type: LOAD_COMMENT_SUCCESS, payload: response });
      })
      .catch((error) => {
        dispatch({ type: LOAD_COMMENT_ERROR, payload: error.message });
      });
  };

export const getReactionComment = ({ huggg, reaction }) => {
  if (!reaction.message && !reaction.name) {
    return '';
  }

  let comment = reaction.message
    ? `### Message sent to ${huggg.huggg.from_name}\n\n${reaction.message}`
    : '';

  if (reaction.name) {
    comment += `\n\n**\- ${reaction.name}**`; // eslint-disable-line no-useless-escape
  }
  return comment;
};

export const getReactionEmoji = ({ huggg, reaction }) =>
  huggg?.huggg?.reaction?.emoji ?? reaction?.emoji;

export const getReactionDisabled = ({ huggg }) => {
  if (huggg.huggg.isSuperhuggg) {
    return true;
  }

  return false;
};

export const getLoadingEmoji = ({ reaction }) => reaction.loadingEmoji;
export const getLoadingComment = ({ reaction }) => reaction.loadingComment;
export const getLoadingEmojiError = ({ reaction }) =>
  reaction.loadingEmojiError;
export const getLoadingCommentError = ({ reaction }) =>
  reaction.loadingCommentError;
